import React, { useEffect, useState, useImperativeHandle } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

// Material-UI Components
import { makeStyles } from "@material-ui/core/styles";

// Custom Components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomOutlinedInput.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
import CustomDialog from "components/CustomDialog/CustomDialog.js";
import CustomToogle from "components/CustomToogle/CustomToogle.js";
import Button from "components/CustomButtons/CustomButton";
import SelectVehicleModal from "components/Vehicle/SelectVehicleModal";

// Utility Functions
import { isAgent } from "components/Utils/utils.js";

// Styles
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import { useTranslation } from "react-i18next";
// Services
import {
  getMakes,
  getModels,
  validateVin,
} from "views/Services/VehiclesService";
import { getRatesRedesign } from "views/Services/OrdersService";

const useStylesPrincipal = makeStyles(stylePrincipal);
const useStyles = makeStyles(styles);
let current_date = new Date();

const Step1 = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  useImperativeHandle(ref, () => ({
    getDataVinVehicle,
    saveStepComplete,
  }));

  const getDataVinVehicle = (vehicleData) => {
    getVinVehicle(vehicleData.vin, vehicleData.vehtype, true, vehicleData);
  };

  const saveStepComplete = (save) => {
    handleSubmitStep(save);
  };

  const {
    submitAction,
    previewAction,
    vehicles,
    vinPolicy,
    setVinPolicy,
    isLogged,
  } = props;
  const routeParams = useParams();
  const { type } = routeParams;
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [openVehicleSelectModal, setOpenVehicleSelectModal] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const classesPrincipal = useStylesPrincipal();
  const [checked, setChecked] = React.useState([]);
  const [vinResponse, setVinResponse] = useState(null);
  const [years, setYears] = useState([]);
  const [makesCatalog, setMakesCatalog] = useState([]);
  const [showSelectMake, setShowSelectMake] = useState(false);
  const [modelsCatalog, setModelsCatalog] = useState([]);
  const [fieldEndorsement, setFieldEndorsement] = useState([]);
  const [loginCredentials, setLoginCredentials] = useState({
    login: "",
    password: "",
  });
  const [sended, setSended] = useState(false);
  const classes = useStyles();
  const [vehicleData, setVehicleData] = useState({
    vehtype: 1,
    agent: 441,
  });
  const [valores, setValores] = useState([]);

  const [secondTowedUnits, setSecondTowedUnits] = useState(false);
  const [gettingQuote, setGettingQuote] = useState(false);
  const [coverages, setCoverages] = useState({
    csllimit: "500000",
    excessliab: "150000",
    country: 0,
    policy_type: 1,
    medicallimit: "5000",
    damageded: 2,
    theftded: 5,
    vehtype: 1,
    year_vehicle: 2025,
    specialdiscount: 1,
    effectivedate: "10-23-2024",
    bordercross: 2,
    gapcoverage: "no",
    premierepackage: true,
    fixeddeductible: true,
    policycaravan: false,
    roadside: true,
    physical_damage: true,
    theft: true,
    legalaid: true,
    hdiautoguard: false,
    accessories_and_safety: false,
    ter_ext: false,
  });
  const [resultRates, setResultRates] = useState({});

  useEffect(() => {
    if (props.data) {
      setData(props.data);
      setValuesForTypeVehicle(1, {});
      checkEndorsementType(props.data.coverages.endorsementtype);
    }
    if (props.coverages) {
      setCoverages(props.coverages);
    }
    if (props.vehicleData) {
      setVehicleData(props.vehicleData);
      if (vinPolicy && vehicleData.vin) {
        getVinVehicle();
        handleToggle({}, 1);
        if ([1, 5].includes(parseInt(vehicleData.vehtype))) {
          getMakesData(props.vehicleData);
          getModelsData(props.vehicleData);
        }
        setVinPolicy(false);
      }
      if (props.vehicleData.other == "1") {
        setSecondTowedUnits(true);
      }
    }
    if (!years.length) {
      const currentYear = new Date().getFullYear() + 1;
      const arreglo = [];
      for (let index = currentYear; index >= currentYear - 59; index--) {
        arreglo.push(index);
      }
      setYears(arreglo);
    }
  }, [props]);

  useEffect(() => {
    if (type === "oneClickLogin") {
      setOneClickLogin(true);
    }
    if (window.location.href.includes("checkTokenOneClick")) {
      setOneClicValidate(true);
      validateToken();
    }
  }, [dispatch]);

  const handlePreviewAction = async () => {
    previewAction();
  };

  const checkEndorsementType = (endorsementType) => {
    if (endorsementType == "Change Vehicle Year") {
      setFieldEndorsement("year_vehicle");
    }
    if (endorsementType == "Change Vehicle Make") {
      setFieldEndorsement("make");
    }
    if (endorsementType == "Change Vehicle Model") {
      setFieldEndorsement("model");
    }
    if (endorsementType == "Change Vehicle VIN") {
      setFieldEndorsement("vin");
    }
    if (endorsementType == "Change Vehicle Plate") {
      setFieldEndorsement("plate");
    }
    if (endorsementType == "Change Vehicle Other Make") {
      setFieldEndorsement("other_make");
    }
    if (endorsementType == "Change Vehicle Other Model") {
      setFieldEndorsement("other_model");
    }
    if (endorsementType == "Change Vehicle Other VIN") {
      setFieldEndorsement("other_vin");
    }
    if (endorsementType == "Change Vehicle Other Plate") {
      setFieldEndorsement("other_plate");
    }
    if (endorsementType == "Change Policy Lienholder") {
      setFieldEndorsement("lienholder");
    }
    if (endorsementType == "Change Policy Lienholder Address") {
      setFieldEndorsement("lienholder_address");
    }
  };

  const handleSubmitStep = async () => {
    const makeData = makesCatalog.find((e) => e.id === vehicleData.makeVehicle);
    const modelData = modelsCatalog.find(
      (e) => e.id === vehicleData.vehicleModel
    );
    vehicleData.vehText = `${vehicleData.vehicleYear} ${
      makeData ? makeData.name : ""
    } ${modelData ? modelData.name : ""}`;
    submitAction(vehicleData);
  };
  const getVinVehicle = async (
    vin,
    vehType,
    fromQuote,
    vehicleDataFromQuote
  ) => {
    const vinToValidate = typeof vin !== "undefined" ? vin : vehicleData.vin;
    const vehTypeToValidate =
      typeof vehType !== "undefined" ? vehType : vehicleData.vehType;
    if (vinToValidate && /^[a-zA-Z0-9]{17}$/.test(vinToValidate.trim())) {
      const resultSubmit = await dispatch(
        validateVin({
          vin: vinToValidate.trim(),
          vehicleTypeId: vehTypeToValidate,
        })
      );
      if (["Trailer", "Other"].includes(fromQuote)) {
        return resultSubmit.payload;
      } else {
        setVinResponse(resultSubmit.payload);
        if (resultSubmit.payload.result) {
          let tempVehicleData = setVehicleDataFromList(
            resultSubmit.payload.vehicleData
          );

          if (fromQuote === true) {
            tempVehicleData.makeVehicle = vehicleDataFromQuote.vehicleMake;
            tempVehicleData.vehicleModel = vehicleDataFromQuote.vehicleModel;
          }

          setVehicleData(tempVehicleData);
          getMakesData(tempVehicleData);
          getModelsData(tempVehicleData);
          validateComplete(tempVehicleData);
        } else {
          if (resultSubmit.payload.vehicleData) {
            let dataVehicle = resultSubmit.payload.vehicleData;
            if (["1", "4", "5", "11"].includes(dataVehicle.vehicleTypeId)) {
              const tempVehicleData = setVehicleDataFromList(
                resultSubmit.payload.vehicleData
              );
              if (
                resultSubmit.payload.message.includes(
                  "The vehicle value has been set to liability only"
                )
              ) {
                tempVehicleData.total_value_vehicle = 0;
                tempVehicleData.fullCoverage = "no";
              }
              setVehicleData(tempVehicleData);
              getMakesData(tempVehicleData);
              getModelsData(tempVehicleData);
              validateComplete(tempVehicleData);
            }
          }
          if (
            resultSubmit.payload.message.includes(
              "This vehicle may be ineligible for coverage under this program"
            )
          ) {
            setIsCompleted(false);
          } else if (
            resultSubmit.payload.message.includes(
              "Please verify that the vehicle information is correct"
            )
          ) {
            const currentIndex = checked.indexOf(1);
            const newChecked = [...checked];

            if (currentIndex === -1) {
              newChecked.push(1);
            }
            //setChecked(newChecked);
            const tempVehicleData = setVehicleDataFromList(
              resultSubmit.payload.vehicleData
            );

            setVehicleData(tempVehicleData);
            getMakesData(tempVehicleData);
            getModelsData(tempVehicleData);
            validateComplete(tempVehicleData);
          } else if (resultSubmit.payload.message.includes("VIN not found")) {
            let tempVehicleData = { ...vehicleData };
            setNotFoundVehicleDataVin(tempVehicleData, vehType, fromQuote);
            setIsCompleted(fromQuote === true ? true : false);
          }
        }
      }
    } else {
      setVinResponse({
        result: false,
        message:
          "The VIN isn't valid; please enter a valid 17-digit VIN and try again",
      });
    }
  };

  const setNotFoundVehicleDataVin = (tempVehicleData, vehType, fromQuote) => {
    if (typeof fromQuote === "undefined") {
      tempVehicleData.vehicleYear = null;
      tempVehicleData.vehicleModel = null;
      //tempVehicleData.vehicle_type_id = vehicleDataResult.vehicleTypeId;
      tempVehicleData.vehtype = "1";
      tempVehicleData.year_model = null;
      tempVehicleData.makeId = null;
      tempVehicleData.make_vehicle = null;
      tempVehicleData.modelId = null;
      tempVehicleData.model = null;
      setVehicleData(tempVehicleData);
      setShowSelectMake(true);
    } else {
      let typeValuesVehicle = false;
      if (["1", "5"].includes(vehType)) {
        typeValuesVehicle = true;
        getMakesData(tempVehicleData);
        getModelsData(tempVehicleData);
      }
      setShowSelectMake(typeValuesVehicle);
      handleToggle({}, 1);
      setIsCompleted(true);
    }
  };

  const setVehicleDataFromList = (vehicleDataResult) => {
    let tempVehicleData = { ...vehicleData };
    tempVehicleData.vehicleYear = vehicleDataResult.vehicleYear;
    tempVehicleData.makeVehicle = ["1", "5"].includes(
      vehicleDataResult.vehicleTypeId
    )
      ? vehicleDataResult.vehicleMakeId
      : vehicleDataResult.vehicleMakeName;
    tempVehicleData.vehicleModel = ["1", "5"].includes(
      vehicleDataResult.vehicleTypeId
    )
      ? vehicleDataResult.vehicleModelId
      : vehicleDataResult.vehicleModelName;
    tempVehicleData.vehicle_type_id = vehicleDataResult.vehicleTypeId;
    tempVehicleData.vehtype =
      vehicleDataResult.vehicleTypeId == null
        ? "1"
        : vehicleDataResult.vehicleTypeId;
    tempVehicleData.towingUnits = "no";
    tempVehicleData.year_model = vehicleDataResult.vehicleYear;
    tempVehicleData.makeId = vehicleDataResult.vehicleMakeId;
    tempVehicleData.make_vehicle = vehicleDataResult.vehicleMakeName;
    tempVehicleData.modelId = vehicleDataResult.vehicleModelId;
    tempVehicleData.model = vehicleDataResult.vehicleModelName;
    tempVehicleData.make = vehicleDataResult.vehicleMakeName;
    return tempVehicleData;
  };

  const selectVehicle = async (vehicle) => {
    setVinResponse({
      result: true,
      message: "Validated",
      vehicleData: {
        vehicleType: vehicle.type_name,
        vehicleTypeId: vehicle.vehicle_type_id,
        vehicleYear: vehicle.year_model,
        vehicleMakeId: vehicle.makeId,
        vehicleMakeName: vehicle.make_vehicle,
        vehicleModelId: vehicle.modelId,
        vehicleModelName: vehicle.model,
      },
    });
    let tempVehicleData = { ...vehicleData };
    Object.assign(tempVehicleData, vehicle);
    tempVehicleData.vehicleYear = vehicle.year_model;
    tempVehicleData.makeVehicle = vehicle.makeId;
    tempVehicleData.vehicleModel = vehicle.modelId;
    tempVehicleData.licensePlate = vehicle.plates;
    tempVehicleData.total_value_vehicle = vehicle.total_value;
    tempVehicleData.insuranceCompany = vehicle.insurance_company;
    setVehicleData(tempVehicleData);
    getMakesData(tempVehicleData);
    getModelsData(tempVehicleData);
    setOpenVehicleSelectModal(false);
    validateComplete(tempVehicleData);
  };

  const handleFormChange = (e) => {
    const valor = e.target.value;
    let vehData = { ...vehicleData };
    vehData[e.target.name] = valor;
    if (e.target.name === "days") {
      vehData.selectedDays = valor;
    }
    if (e.target.name === "vehtype" || e.target.name === "vehicleYear") {
      if (e.target.name === "vehtype") {
        vehData.vehicle_type_id = valor;
        vehData.year_vehicle = vehicleData.year_vehicle;
        vehData.year_model = vehicleData.year_vehicle;
        vehData.type_name = e.nativeEvent.target.textContent;
      } else {
        vehData.vehtype = vehicleData.vehtype;
        vehData.vehicle_type_id = vehicleData.vehtype;
        vehData.year_vehicle = valor;
      }
      setValuesForTypeVehicle(valor, vehData);
      getMakesData(vehData);
    } else if (e.target.name === "makeVehicle") {
      vehData.makeId = null;
      vehData.vehtype = vehicleData.vehtype;
      if (showSelectMake) {
        vehData.makeId = valor;
        getModelsData(vehData);
      }
      vehData.make_vehicle = valor;
      vehData.make = valor;
    }
    if (e.target.name === "vehicleYear") {
      vehData.year_model = e.nativeEvent.target.textContent;
      vehData.make_vehicle = "";
      vehData.makeId = null;
      vehData.modelId = null;
      vehData.vehicleModel = "";
    }
    if (e.target.name === "make_vehicle") {
      vehData.make_name = ["1", "5"].includes(vehData.vehtype)
        ? e.nativeEvent.target.textContent
        : valor;
      vehData.makeId = valor;
      vehData.vehicleModel = "";
      vehData.modelId = null;
    }
    if (e.target.name === "vehicleModel") {
      vehData.modelId = null;
      vehData.model_name = valor;
      vehData.model = valor;
      if (showSelectMake) {
        vehData.model_name = e.nativeEvent.target.textContent;
        vehData.modelId = valor;
      }
    }
    if (e.target.name === "total_value_vehicle") {
      vehData.total_value = valor;
    }
    if (e.target.name === "towed_total_value_vehicle") {
      vehData.total_value_trailer = valor;
    }
    if (e.target.name === "towed_vin") {
      vehData.vin_trailer = valor;
      vehData.vehtype_trailer = 1;
    }
    if (e.target.name === "towed_vehicleYear") {
      vehData.year_model_trailer = valor;
    }
    if (e.target.name === "towed_make") {
      vehData.make_trailer = valor;
    }
    if (e.target.name === "towed_model") {
      vehData.model_trailer = valor;
    }
    if (e.target.name === "secondary_total_value_vehicle") {
      vehData.total_value_other = valor;
    }
    if (e.target.name === "secondary_vin") {
      vehData.vin_other = valor;
      vehData.vehtype_other = 2;
    }
    if (e.target.name === "secondary_vehicleYear") {
      vehData.year_model_other = valor;
    }
    if (e.target.name === "secondary_make") {
      vehData.make_other = valor;
    }
    if (e.target.name === "secondary_model") {
      vehData.model_other = valor;
    }
    if (e.target.name === "licensePlate") {
      vehData.plates = valor;
    }
    if (e.target.name === "lienholderName") {
      vehData.lienholder = valor;
    }
    if (e.target.name === "lienholderAddress") {
      vehData.lienholder_vehicle_address = valor;
    }
    if (e.target.name === "fullCoverage") {
      vehData.insurancepolnumber = valor;
      vehData.insurance_policy_number = valor;
      setValuesForTypeVehicle(1, vehData);
    }
    if (e.target.name === "insuranceCompany") {
      vehData.insurance_company = valor;
    }
    if (vehData.initDate && vehData.endDate) {
      const initDate = new Date(vehData.initDate);
      const endDate = new Date(vehData.endDate);
      const diffTime = Math.abs(endDate - initDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      vehData.days = diffDays;
    }
    setVehicleData(vehData);
    validateComplete(vehData);
  };

  const validateComplete = (data) => {
    //changeStep(data, coveragesData);
    const reqProperties = [
      "vehtype",
      "licensePlate",
      "total_value_vehicle",
      "fullCoverage",
      "insuranceCompany",
    ];
    if (data.vehicle_type_id !== "11") {
      reqProperties.push("makeVehicle");
    }
    if (data.hasLienholder === "yes") {
      reqProperties.push("lienholderName");
    }
    if (checked.indexOf(1) === 0) {
      reqProperties.push("vehicleYear", "makeVehicle", "vehicleModel");
    }
    if (data.towingUnits === "yes") {
      reqProperties.push(
        "towed_total_value_vehicle",
        "towed_vin",
        "towed_vehicleYear",
        "towed_make",
        "towed_model"
      );
      if (secondTowedUnits) {
        reqProperties.push(
          "secondary_total_value_vehicle",
          "secondary_vin",
          "secondary_vehicleYear",
          "secondary_make",
          "secondary_model"
        );
      }
    }
    const allPropertiesValid = reqProperties.every((prop) => {
      console.log("Validating prop:", prop, data[prop]);
      return (
        data[prop] !== undefined && data[prop] !== null && data[prop] !== ""
      );
    });
    let validVehicle =
      !vinResponse ||
      !vinResponse.message.includes(
        "This vehicle may be ineligible for coverage under this program"
      );
    console.log("validVehicle:", validVehicle);
    setIsCompleted(allPropertiesValid && validVehicle);
  };
  const getMakesData = async (sendedData) => {
    //sendedData.vehtype = sendedData.vehtype === null ? "1" : sendedData.vehtype;
    if (sendedData.vehtype && sendedData.vehicleYear) {
      const sendedVehicle =
        sendedData.vehtype === "1"
          ? "P"
          : sendedData.vehtype === "5"
          ? "M"
          : null;
      if (sendedVehicle) {
        setShowSelectMake(true);
        const resultSubmit = await dispatch(
          getMakes({
            year: sendedData.vehicleYear,
            type_vehicle: sendedVehicle,
          })
        );
        let makeList = resultSubmit.payload.makes;
        if (!makeList) {
          makeList = [{ id: "Other", name: "Other" }];
        } else {
          makeList.unshift({ id: "Other", name: "Other" });
        }
        setMakesCatalog(makeList);
      } else {
        setShowSelectMake(false);
      }
    }
  };
  const getModelsData = async (sendedData) => {
    //sendedData.vehtype = sendedData.vehtype === null ? "1" : sendedData.vehtype;
    const sendedVehicle =
      sendedData.vehtype === "1"
        ? "P"
        : sendedData.vehtype === "5"
        ? "M"
        : null;
    const resultSubmit = await dispatch(
      getModels({
        name: sendedData.makeVehicle,
        type_vehicle: sendedVehicle,
      })
    );
    let modelList = resultSubmit.payload.makes;

    if (parseInt(sendedData.makeVehicle) > 0) {
      if (!modelList) {
        modelList = [{ id: "Other", name: "Other" }];
      } else {
        modelList.unshift({ id: "Other", name: "Other" });
      }
      setModelsCatalog(modelList);
    }
  };

  const setValuesForTypeVehicle = (type, vehData) => {
    let limitValue = 300000;
    type = parseInt(type);
    if ([1, 7, 13].includes(type)) {
      limitValue = 100000;
    }
    if (type == 5) {
      limitValue = 50000;
    }
    if (type == 11) {
      limitValue = 40000;
    }
    if (
      [10, 12].includes(type) ||
      current_date.getFullYear() - vehData.year_vehicle > 25
    ) {
      limitValue = 0;
    }
    formatValueField(limitValue);
  };

  const formatValueField = (limitValue) => {
    if (limitValue == 0) {
      let vehicleDataToEdit = { ...vehicleData };
      vehicleDataToEdit.value = 0;
      setVehicleData(vehicleDataToEdit);
    }
    const arreglov = [];
    for (let index = 0; index <= limitValue; index += 1000) {
      if (index === 0) {
        arreglov.push({ value: index, traduccion: "$0 - Liability only" });
      } else {
        index >= 3000 &&
          arreglov.push({ value: index, traduccion: USDollar.format(index) });
      }
    }
    setValores(arreglov);
  };
  const vehicleValueDisabled = () => {
    let disable = false;
    if (
      vinResponse &&
      vinResponse.message.includes(
        "The vehicle value has been set to liability only"
      )
    ) {
      disable = true;
    }
    return disable;
  };

  const handleToggle = (event, value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
      setIsCompleted(false);
    } else {
      newChecked.splice(currentIndex, 1);
      validateComplete(vehicleData);
    }
    setChecked(newChecked);
  };

  return (
    <div>
      {vehicleData.towingUnits ? (
        <GridItem xs={12} sm={12} md={12}>
          {open ? (
            <CustomDialog open={true} title={"Edit Quote"}></CustomDialog>
          ) : null}
          <div
            className={`${classesPrincipal.title} ${classesPrincipal.black}`}
          >
            {t("step3.title")}
          </div>
          <GridContainer style={{ marginTop: "20px" }}>
            <GridItem xs={12} sm={12} md={8}>
              {isAgent && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <p
                      className={classesPrincipal.labelRoot}
                      style={{ fontSize: "18px", marginBottom: "5px" }}
                    >
                      {t("step3.labels.vehicleOwner")}:{" "}
                      {data?.data_customer?.first_name}{" "}
                      {data?.data_customer?.last_name}
                    </p>
                  </GridItem>
                </GridContainer>
              )}
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomSelect
                    labelText={t("step3.labels.vehicleType")}
                    helperText={
                      !loginCredentials.login && sended
                        ? t("step3.errors.vehicleTypeRequired")
                        : null
                    }
                    menuItems={
                      data?.catalogs
                        ? data.catalogs.vehicle_types.map((item) => ({
                            value: item.id,
                            label: item.name,
                            icon: item.icon,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="vehtype"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      name: "vehtype",
                      id: "vehtypeStep3",
                      required: true,
                      value: vehicleData.vehtype,
                      onChange: handleFormChange,
                      disabled: true,
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={8}>
                  <CustomInput
                    labelText={t("step3.labels.vin")}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    inputProps={{
                      alwaysRed: true,
                      name: "vin",
                      id: "vinStep3",
                      value: vehicleData.vin,
                      onChange: handleFormChange,
                      disabled: fieldEndorsement === "vin" ? false : true,
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomSelect
                    labelText={t("step3.labels.vehicleYear")}
                    helperText={
                      !loginCredentials.login && sended
                        ? t("step3.errors.vehicleValueRequired")
                        : null
                    }
                    menuItems={
                      years
                        ? years.map((item) => ({
                            value: item,
                            label: item,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="vehicleYear"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "vehicleYear",
                      id: "vehicleYearStep3",
                      value: vehicleData.vehicleYear,
                      onChange: handleFormChange,
                      disabled:
                        fieldEndorsement === "year_vehicle" ? false : true,
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  {showSelectMake && (
                    <CustomSelect
                      labelText={t("step3.labels.vehicleMake")}
                      helperText={
                        !loginCredentials.login && sended
                          ? t("step3.errors.vehicleValueRequired")
                          : null
                      }
                      menuItems={
                        makesCatalog
                          ? makesCatalog.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))
                          : []
                      }
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="makeVehicle"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "makeVehicle",
                        id: "makeVehicleStep3",
                        value: vehicleData.makeVehicle,
                        onChange: handleFormChange,
                        disabled:
                          fieldEndorsement === "make" ||
                          fieldEndorsement === "year_vehicle"
                            ? false
                            : true,
                      }}
                    />
                  )}
                  {!showSelectMake && (
                    <CustomInput
                      labelText={t("step3.labels.vehicleMake")}
                      error={
                        !loginCredentials.login && sended
                          ? t("step3.errors.vehicleValueRequired")
                          : null
                      }
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        required: true,
                        name: "makeVehicle",
                        id: "makeVehicleStep3",
                        value: vehicleData.makeVehicle,
                        onChange: handleFormChange,
                        disabled:
                          fieldEndorsement === "make" ||
                          fieldEndorsement === "year_vehicle"
                            ? false
                            : true,
                      }}
                    />
                  )}
                </GridItem>

                <GridItem xs={12} sm={12} md={4}>
                  {showSelectMake && (
                    <CustomSelect
                      labelText={t("step3.labels.vehicleModel")}
                      helperText={
                        !loginCredentials.login && sended
                          ? t("step3.errors.vehicleValueRequired")
                          : null
                      }
                      menuItems={
                        modelsCatalog
                          ? modelsCatalog.map((item) => ({
                              value: item.id,
                              label: item.name,
                            }))
                          : []
                      }
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="vehicleModel"
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "vehicleModel",
                        id: "vehicleModelStep3",
                        value: vehicleData.vehicleModel,
                        onChange: handleFormChange,
                        disabled:
                          fieldEndorsement === "model" ||
                          fieldEndorsement === "make" ||
                          fieldEndorsement === "year_vehicle"
                            ? false
                            : true,
                      }}
                    />
                  )}
                  {!showSelectMake && (
                    <CustomInput
                      labelText={t("step3.labels.vehicleModel")}
                      error={
                        !loginCredentials.login && sended
                          ? t("step3.errors.vehicleValueRequired")
                          : null
                      }
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      inputProps={{
                        required: true,
                        name: "vehicleModel",
                        id: "vehicleModelStep3",
                        value: vehicleData.vehicleModel,
                        onChange: handleFormChange,
                        disabled:
                          fieldEndorsement === "model" ||
                          fieldEndorsement === "make" ||
                          fieldEndorsement === "year_vehicle"
                            ? false
                            : true,
                      }}
                    />
                  )}
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText={t("step3.labels.licensePlate")}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    inputProps={{
                      required: true,
                      name: "licensePlate",
                      id: "licensePlateStep3",
                      value: vehicleData.licensePlate,
                      onChange: handleFormChange,
                      disabled: fieldEndorsement === "plate" ? false : true,
                    }}
                  />
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomSelect
                    labelText={t("step3.labels.vehicleValue")}
                    placeholder={t("step3.placeholders.actualCashValue")}
                    helperText={
                      !loginCredentials.login && sended
                        ? t("step3.errors.vehicleValueRequired")
                        : null
                    }
                    menuItems={
                      valores
                        ? valores.map((item) => ({
                            value: item.value,
                            label: item.traduccion,
                          }))
                        : []
                    }
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="total_value_vehicle"
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      disabled: vehicleValueDisabled(),
                      name: "total_value_vehicle",
                      id: "total_value_vehicleStep3",
                      value: vehicleData.total_value_vehicle,
                      onChange: handleFormChange,
                      disabled: true,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomToogle
                    labelText={t("step3.labels.fullCoverage")}
                    items={[
                      { value: "yes", label: t("step3.options.yes") },
                      { value: "no", label: t("step3.options.no") },
                    ]}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="fullCoverage"
                    defaultValue={vehicleData.fullCoverage || "yes"}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "fullCoverage",
                      id: "fullCoverageStep3",
                      value: vehicleData.fullCoverage,
                      onChange: handleFormChange,
                      disabled:
                        fieldEndorsement === "insurance_policy_number"
                          ? false
                          : true,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText={t("step3.labels.insuranceCompany")}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    inputProps={{
                      required: true,
                      name: "insuranceCompany",
                      id: "insuranceCompanyStep3",
                      value: vehicleData.insuranceCompany,
                      onChange: handleFormChange,
                      disabled:
                        fieldEndorsement === "insurance_company" ? false : true,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomToogle
                    labelText={t("step3.labels.hasLienholder")}
                    items={[
                      { value: "yes", label: t("step3.options.yes") },
                      { value: "no", label: t("step3.options.no") },
                    ]}
                    error={!loginCredentials.login && sended ? true : null}
                    formControlProps={{
                      fullWidth: true,
                      className: classes.customFormControlClasses,
                    }}
                    name="hasLienholder"
                    defaultValue={vehicleData.hasLienholder || "no"}
                    onChange={(e) => handleFormChange(e)}
                    inputProps={{
                      required: true,
                      name: "hasLienholder",
                      id: "hasLienholderStep3",
                      value: vehicleData.hasLienholder,
                      onChange: handleFormChange,
                      disabled: true,
                    }}
                  />
                </GridItem>
              </GridContainer>

              {vehicleData.hasLienholder === "yes" ? (
                <>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={8}>
                      <CustomInput
                        labelText={t("step3.labels.lienholderName")}
                        error={!loginCredentials.login && sended ? true : null}
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses,
                        }}
                        inputProps={{
                          required: true,
                          name: "lienholderName",
                          id: "lienholderNameStep3",
                          value: vehicleData.lienholderName,
                          onChange: handleFormChange,
                          disabled:
                            fieldEndorsement === "lienholder" ? false : true,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={8}>
                      <CustomInput
                        labelText={t("step3.labels.lienholderAddress")}
                        error={!loginCredentials.login && sended ? true : null}
                        formControlProps={{
                          fullWidth: true,
                          className: classes.customFormControlClasses,
                        }}
                        inputProps={{
                          name: "lienholderAddress",
                          id: "lienholderAddressStep3",
                          value: vehicleData.lienholderAddress,
                          onChange: handleFormChange,
                          disabled:
                            fieldEndorsement === "lienholder_address"
                              ? false
                              : true,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                </>
              ) : null}
              {vehicleData.vehtype !== "11" && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomToogle
                      information="Tooltip Text"
                      labelText={t("step3.labels.willTowing")}
                      helperText={null}
                      items={[
                        { value: "yes", label: t("step3.options.yes") },
                        { value: "no", label: t("step3.options.no") },
                      ]}
                      error={!loginCredentials.login && sended ? true : null}
                      formControlProps={{
                        fullWidth: true,
                        className: classes.customFormControlClasses,
                      }}
                      name="towingUnits"
                      defaultValue={
                        vehicleData.towingUnits ? vehicleData.towingUnits : ""
                      }
                      onChange={(e) => handleFormChange(e)}
                      inputProps={{
                        required: true,
                        name: "towingUnits",
                        id: "towingUnitsStep3",
                        value: vehicleData.towingUnits,
                        onChange: handleFormChange,
                        disabled: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
              )}
              {vehicleData.vehtype !== "11" &&
                vehicleData.towingUnits === "yes" && (
                  <>
                    <span
                      className={`${classesPrincipal.subTitle} ${classesPrincipal.green}`}
                    >
                      {t("step3.titleTowed")}
                    </span>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <CustomSelect
                          labelText={t("step3.labels.towedUnitValue")}
                          secondaryText={t("step3.helperTexts.towedUnitValue")}
                          placeholder={t("step3.placeholders.actualCashValue")}
                          helperText={
                            !loginCredentials.login && sended
                              ? t("step3.errors.vehicleValueRequired")
                              : null
                          }
                          menuItems={
                            valores
                              ? valores.map((item) => ({
                                  value: item.value,
                                  label: item.traduccion,
                                }))
                              : []
                          }
                          error={!loginCredentials.login && sended}
                          formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses,
                          }}
                          name="towed_total_value_vehicle"
                          onChange={(e) => handleFormChange(e)}
                          inputProps={{
                            name: "towed_total_value_vehicle",
                            id: "towed_total_value_vehicleStep3",
                            value:
                              vehicleData.towed_total_value_vehicle != null
                                ? vehicleData.towed_total_value_vehicle
                                : "placeholder",

                            onChange: handleFormChange,
                            disabled: true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={8}>
                        <CustomInput
                          labelText={t("step3.labels.towedVin")}
                          error={
                            !loginCredentials.login && sended ? true : null
                          }
                          formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses,
                          }}
                          inputProps={{
                            name: "towed_vin",
                            id: "towed_vinStep3",
                            value: vehicleData.towed_vin,
                            onChange: handleFormChange,
                            disabled:
                              fieldEndorsement === "other_vin" ? false : true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <CustomSelect
                          labelText={t("step3.labels.towedUnitYear")}
                          helperText={
                            !loginCredentials.login && sended
                              ? t("step3.errors.vehicleYearRequired")
                              : null
                          }
                          menuItems={
                            years
                              ? years.map((item) => ({
                                  value: item,
                                  label: item,
                                }))
                              : []
                          }
                          error={!loginCredentials.login && sended}
                          formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses,
                          }}
                          name="towed_vehicleYear"
                          onChange={(e) => handleFormChange(e)}
                          inputProps={{
                            name: "towed_vehicleYear",
                            id: "towed_vehicleYearStep3",
                            value: vehicleData.towed_vehicleYear,
                            onChange: handleFormChange,
                            disabled: true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText={t("step3.labels.towedUnitMake")}
                          error={
                            !loginCredentials.login && sended ? true : null
                          }
                          formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses,
                          }}
                          inputProps={{
                            name: "towed_make",
                            id: "towed_makeStep3",
                            value: vehicleData.towed_make,
                            onChange: handleFormChange,
                            disabled:
                              fieldEndorsement === "other_make"
                                ? false
                                : true,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <CustomInput
                          labelText={t("step3.labels.towedUnitModel")}
                          error={
                            !loginCredentials.login && sended ? true : null
                          }
                          formControlProps={{
                            fullWidth: true,
                            className: classes.customFormControlClasses,
                          }}
                          inputProps={{
                            name: "towed_model",
                            id: "towed_modelStep3",
                            value: vehicleData.towed_model,
                            onChange: handleFormChange,
                            disabled:
                              fieldEndorsement === "other_model"
                                ? false
                                : true,
                          }}
                        />
                      </GridItem>
                    </GridContainer>

                    {secondTowedUnits && (
                      <>
                        <div style={{ marginTop: "25px" }}>
                          <span
                            className={`${classesPrincipal.subTitle} ${classesPrincipal.green}`}
                          >
                            {t("step3.titlesTows")}
                          </span>
                        </div>

                        <GridContainer>
                          <GridItem xs={12} sm={12} md={6}>
                            <CustomSelect
                              labelText={t("step3.labels.towedUnitValue")}
                              placeholder={t(
                                "step3.placeholders.actualCashValue"
                              )}
                              helperText={
                                !loginCredentials.login && sended
                                  ? t("step3.errors.vehicleValueRequired")
                                  : null
                              }
                              menuItems={
                                valores
                                  ? valores.map((item) => ({
                                      value: item.value,
                                      label: item.traduccion,
                                    }))
                                  : []
                              }
                              error={!loginCredentials.login && sended}
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses,
                              }}
                              name="secondary_total_value_vehicle"
                              onChange={(e) => handleFormChange(e)}
                              inputProps={{
                                name: "secondary_total_value_vehicle",
                                id: "secondary_total_value_vehicleStep3",
                                value:
                                  vehicleData.secondary_total_value_vehicle !=
                                  null
                                    ? vehicleData.secondary_total_value_vehicle
                                    : "placeholder",

                                onChange: handleFormChange,
                                disabled: true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>

                        <GridContainer>
                          <GridItem xs={12} sm={12} md={8}>
                            <CustomInput
                              labelText={t("step3.labels.towedVin")}
                              error={
                                !loginCredentials.login && sended ? true : null
                              }
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses,
                              }}
                              inputProps={{
                                name: "secondary_vin",
                                id: "secondary_vinStep3",
                                value: vehicleData.secondary_vin,
                                onChange: handleFormChange,
                                disabled:
                                  fieldEndorsement === "other_vin"
                                    ? false
                                    : true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>

                        <GridContainer>
                          <GridItem xs={12} sm={12} md={4}>
                            <CustomSelect
                              labelText={t("step3.labels.towedUnitYear")}
                              helperText={
                                !loginCredentials.login && sended
                                  ? t("step3.errors.vehicleYearRequired")
                                  : null
                              }
                              menuItems={
                                years
                                  ? years.map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                  : []
                              }
                              error={!loginCredentials.login && sended}
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses,
                              }}
                              name="secondary_vehicleYear"
                              onChange={(e) => handleFormChange(e)}
                              inputProps={{
                                name: "secondary_vehicleYear",
                                id: "secondary_vehicleYearStep3",
                                value: vehicleData.secondary_vehicleYear,
                                onChange: handleFormChange,
                                disabled: true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>

                        <GridContainer>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                              labelText={t("step3.labels.towedUnitMake")}
                              error={
                                !loginCredentials.login && sended ? true : null
                              }
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses,
                              }}
                              inputProps={{
                                name: "secondary_make",
                                id: "secondary_makeStep3",
                                value: vehicleData.secondary_make,
                                onChange: handleFormChange,
                                disabled:
                                  fieldEndorsement === "other_make"
                                    ? false
                                    : true,
                              }}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={3}>
                            <CustomInput
                              labelText={t("step3.labels.towedUnitModel")}
                              error={
                                !loginCredentials.login && sended ? true : null
                              }
                              formControlProps={{
                                fullWidth: true,
                                className: classes.customFormControlClasses,
                              }}
                              inputProps={{
                                name: "secondary_model",
                                id: "secondary_modelStep3",
                                value: vehicleData.secondary_model,
                                onChange: handleFormChange,
                                disabled:
                                  fieldEndorsement === "other_model"
                                    ? false
                                    : true,
                              }}
                            />
                          </GridItem>
                        </GridContainer>

                        <GridContainer>
                          <GridItem xs={12} sm={12} md={3}>
                            <Button
                              id="loginMobile"
                              type="submit"
                              onClick={() => {
                                setSecondTowedUnits(false);
                                let vehData = vehicleData;
                                vehData.other = "0";
                                setVehicleData(vehData);
                              }}
                              variant="green"
                            >
                              {t("step3.buttons.removeSecondTowedUnit")}
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </>
                    )}
                  </>
                )}

              <GridContainer
                container
                justifyContent="space-between"
                alignItems="center"
                style={{ minHeight: "100px", marginTop: "20px" }}
              >
                <GridItem xs={4}>
                  <Button
                    id={isLogged ? "previousStep3" : "previousStep3Guest"}
                    onClick={handlePreviewAction}
                    variant="white"
                    style={{ width: "100%" }}
                  >
                    {t("common.previous")}
                  </Button>
                </GridItem>

                <GridItem xs={4} />
                <GridItem xs={4}>
                  <Button
                    id={isLogged ? "continueStep3" : "continueStep3Guest"}
                    type="submit"
                    onClick={handleSubmitStep}
                    disabled={!isCompleted}
                    variant="green"
                    style={{ width: "100%" }}
                  >
                    {t("common.continue")}
                  </Button>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </GridItem>
      ) : null}
      <SelectVehicleModal
        open={openVehicleSelectModal}
        setOpen={setOpenVehicleSelectModal}
        selectVehicle={selectVehicle}
        vehicles={vehicles}
      ></SelectVehicleModal>
    </div>
  );
});

Step1.displayName = "Step1";

export default Step1;
